module.exports = __webpack_public_path__ + "img/item3.ec0d7e9a.jpg";